export default "__VITE_ASSET__wC$iznNV__"